<template>
    <div class="flex-center relative">
        <slot></slot>
        <el-popover
            placement="top-start"
            :title="title"
            :width="width"
            trigger="hover"
            popper-class="tipClass"
            :content="content">
            <img slot="reference" class="i-help" src="@/assets/tip-icon.png" alt="">
        </el-popover> 
    </div>
</template>
<script>
export default {
    name: 'Tip',
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        width: {
            type: Number,
            default: 200
        }
    }
}
</script>
<style lang="scss" scoped>
.relative {
    position: relative;
    padding-right: 10px;
    .i-help {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: -10px;
        width: 14px;
        height: 14px;
        cursor: pointer;
    }   
}
</style>